import { z } from 'zod'
import { StationTWN } from '@library/enums'

/** 場站 Schema */
export const stationSchema = z.object({
  areaCode: z.string(),
  countryCode: z.string(),
  code: z.union([z.enum(StationTWN), z.string()]),
  name: z.string(),
  enable: z.boolean()
})

/** 場站 */
export interface Station extends z.infer<typeof stationSchema> {}
